<template>
    <div class="home_page">
        <!--banner start -->
        <div class="banana_box">
            <img src="../../../public/img/homePage/banner1.png" alt="">
        </div>
        <!--banner end -->

        <!--关于我们  start-->
        <div class="contentWidth about_my ly_flex ly_flex_just_between">
            <div>
                <img class="left_img" src="../../../public/img/homePage/aboutMy.png" alt="">
            </div>
            <div class="right_box">
                <h3>关于我们</h3>
                <div class="about_text ly_flex ly_flex_col ly_flex_just_between">
                    <p>西安智徽信息工程有限公司成立于2007年12月，是集研发、销售、客服、咨询于一体的人口健康信息化整体解决方案供应商，拥有高端开发人才30余人。</p>
                    <p>
                        智徽软件产品服务于西安市、安康市、商洛市、西咸新区、渭南市、宝鸡市等地区4千余家卫生院与村卫生室基层医疗机构、100余家县级以上综合医疗机构、40余家卫生管理部门、超过500万城乡居民。</p>
                </div>
                <div class="more" @click="moreFunc('/aboutMy',2)">更多</div>
            </div>
        </div>
        <!--关于我们  end-->

        <!--产品中心 start-->
        <div class="product_center">
            <div class="contentWidth">
                <h2>产品中心</h2>
                <ul class="product_list ly_flex ly_flex_just_between">
                    <li v-for="item in productList" :key="item.key">
                        <img :src="item.imgPath" :alt="item.text">
                        <p>{{item.text}}</p>
                    </li>
                </ul>
                <div class="product_more ly_flex ly_flex_just_center">
                    <span class="more"  @click="moreFunc('/productCenter',1)">更多</span>
                </div>

            </div>
        </div>
        <!--产品中心 end-->

        <!--团队介绍 start-->
        <div class="team_introduction">
            <div class="contentWidth">
                <h2>团队介绍</h2>
                <div class="ly_flex ly_flex_just_between">
                    <img class="team_img" src="../../../public/img/homePage/team.png" alt="">
                    <div class="team_introduction_content">
                        <p>
                            公司拥有一支富有朝气的团队，我们的团队成员来自五湖四海，为了一个共同的梦想走到了一起。我们虽然拥有不同的性格、教育背景和工作经历，但都有一个共同的特点：热爱互联网！
                        </p>
                        <p>
                            我们激情四射，但底蕴丰厚；我们活力无限，也同样耐得住寂寞；我们满怀理想，脚踏实地去实现；我们创想无限，我们拒绝平庸！
                        </p>
                        <p>
                            在这里，我们优势互补，不用担心自己想法的实施局限于自己的能力范围；在这里，我们的每个想法都会得到团队中肯的意见，最终趋于完美；在这里，我们在一起，没有曲高和寡，只有知己相伴；在这里，我们的工作受到应得的肯定，付出一定有回报！
                        </p>
                    </div>
                </div>

            </div>
        </div>
        <!--团队介绍 end-->
    </div>
</template>

<script>
    import {mapActions} from 'vuex';
    export default {
        name: "homePage",
        data() {
            return {
                productList: [
                    {
                        imgPath: require('../../../public/img/homePage/product1.png'),
                        text: '家庭医生管理系统'
                    },
                    {
                        imgPath: require('../../../public/img/homePage/product3.png'),
                        text: '统一支付平台'
                    },
                    {
                        imgPath: require('../../../public/img/homePage/product2.png'),
                        text: '慢性病精细化管理平台'
                    },
                    {
                        imgPath: require('../../../public/img/homePage/product4.png'),
                        text: '智徽健康APP监管端'
                    },
                ]
            }
        },
        methods:{
            ...mapActions(['headIndexAction']),
            moreFunc(path,index){
                this.headIndexAction(index);
                this.$router.push({path});
            }
        }
    }
</script>

<style scoped lang="scss">
    .home_page {
        /*banner*/
        .banana_box {
            img {
                width: 100%;
            }
        }

        /*关于我们*/
        .about_my {
            padding: 107px 0 82px;

            .left_img {
                width: 628px;
                height: 483px;
            }

            .right_box {
                width: 516px;

                h3 {
                    line-height: 40px;
                    font-size: 40px;
                    color: #333333;
                    font-weight: 600;
                }

                .about_text {
                    margin-top: 52px;
                    margin-bottom: 63px;
                    height: 210px;
                    line-height: 32px;
                    font-size: 16px;
                    color: #434343;
                }
            }
        }

        .more {
            display: inline-block;
            width: 64px;
            height: 32px;
            line-height: 30px;
            text-align: center;
            border-radius: 4px;
            font-size: 16px;
            background: #00A1E9;
            color: #ffffff;
            cursor: pointer;
        }

        /*产品中心*/
        .product_center {
            padding-top: 95px;
            width: 100%;
            height: 575px;
            background: #F7F7F7;

            h2 {
                margin-bottom: 65px;
                text-align: center;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #333333;
            }

            .product_list {
                li {
                    img {
                        display: block;
                        width: 266px;
                        height: 266px;
                    }

                    p {
                        line-height: 70px;
                        text-align: center;
                        font-size: 16px;
                        background: #ffffff;
                        color: #444444;
                    }
                }
            }

            .product_more {
                margin-top: 40px;
            }
        }

        /*团队介绍 */
        .team_introduction {
            padding-top: 110px;
            width: 100%;
            height: 675px;

            h2 {
                margin-bottom: 70px;
                text-align: center;
                font-size: 40px;
                line-height: 40px;
                font-weight: 600;
                color: #333333;
            }

            .team_img {
                width: 627px;
                height: 389px;
            }

            .team_introduction_content {
                width: 502px;
                p{
                    letter-spacing:2px;
                    font-size:16px;
                    line-height: 32px;
                    color: #333333;
                }

            }
        }
    }
</style>
